module.exports = __webpack_public_path__ + "media/images/sp/stores/horie/horie_concept_04-c3c3b823db81b10063be2ce5d68afa63.jpg";